module.exports = __webpack_public_path__ + "img/SSLRPICK.8b10e3c5.svg";